module.exports = __webpack_public_path__ + "media/images/credit-icon-065a8ec044c6facb0b975395f1401e0b.svg";